import { IncomeHeaderCell } from "./styles";
import { IncomeHeaderRowProps } from "./types";

export const IncomeHeaderRow: React.FC<IncomeHeaderRowProps> = ({
  columns,
}) => (
  <tr>
    {columns.map((column, index) => (
      <IncomeHeaderCell key={column} scope="col" $numeric={index > 0}>
        {column}
      </IncomeHeaderCell>
    ))}
  </tr>
);
